var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 304.1 31.1",
    style: {
      enableBackground: "new 0 0 304.1 31.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h18.7v6.4H7.5v6.4h9.3v6.4H7.5v11.3H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.3,8.5h7.1v3.7c0,0.5,0,0.9-0.1,1.4h0.1c0.9-3.1,3.7-5.3,7-5.4c0.3,0,0.6,0,0.8,0.1v7.2 c-0.5-0.1-1-0.1-1.5-0.1c-2.5-0.2-4.9,1.4-5.7,3.8c-0.3,1-0.4,2-0.4,3v8.3h-7.4v-22H22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.7,16.8H52v-0.4c0-1.8-1.4-2.4-3.2-2.4c-2.8,0-5.9,2.1-5.9,2.1l-2.6-5.2c2.7-1.8,5.9-2.8,9.2-2.8 c6.2,0,9.9,3.4,9.9,9v13.5h-6.7v-1.3c0-0.5,0-0.9,0.1-1.4h-0.1c-1.3,2.1-3.7,3.4-6.2,3.2c-4.1,0-7.5-2.7-7.5-7.1 C39,17.5,48.3,16.8,51.7,16.8z M48.5,25.4c1.9,0,3.6-2.1,3.6-3.9V21h-0.7c-2.3,0-5,0.7-5,2.5C46.4,24.6,47,25.4,48.5,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.5,8.5h7.1v1.9c0,0.5,0,0.9-0.1,1.4h0.1c1.5-2.5,4.1-3.9,7-3.8c4.4,0,7.9,2,7.9,8.2v14.2h-7.4V17.5 c0-2-0.8-2.9-2.4-2.9c-2-0.1-3.8,1.2-4.3,3.2c-0.3,0.9-0.4,1.9-0.4,2.9v9.7h-7.5V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6,0H99v15.8h2.1l4.3-7.2h8l-6.4,10v0.1l7.3,11.9h-8.4l-4.7-8.5h-2.3v8.5h-7.4L91.6,0L91.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.7,8c6.5,0,10.1,4.5,10.1,10.6c0,0.7-0.2,2.3-0.2,2.3h-13.9c0.5,2.4,2.7,4.1,5.1,3.9 c2.2-0.1,4.3-0.9,6.1-2.2l2.7,5.2c-2.7,2.1-6,3.2-9.4,3.2c-7.8,0-12.1-5.7-12.1-11.5C115.3,13.1,119.6,8,126.7,8z M129.4,16.7 c0.1-1.7-1.2-3.1-2.8-3.1c0,0,0,0-0.1,0c-2.1,0-3.2,1.5-3.5,3.1H129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.9,8.5h7.1v1.9c0,0.5,0,0.9-0.1,1.4h0.1c1.5-2.5,4.1-3.9,7-3.8c4.4,0,7.9,2,7.9,8.2v14.2h-7.4V17.5 c0-2-0.8-2.9-2.4-2.9c-2-0.1-3.8,1.2-4.4,3.2c-0.3,0.9-0.5,1.9-0.4,2.9v9.7h-7.4L140.9,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.4,22.8c1.6,1.3,3.5,2.1,5.6,2.2c1.1,0,2.2-0.3,2.2-1c0-1.9-10.3-2.1-10.3-9.3c0-4.1,4-6.7,9-6.7 s7.7,2.5,7.7,2.5l-2.5,5.2c-1.5-1.1-3.3-1.8-5.2-1.8c-1.1,0-2.2,0.3-2.2,1.1c0,1.7,10.3,1.9,10.3,9c0,3.8-3.3,7-9,7 c-3.2,0-6.4-1.1-8.8-3.2L169.4,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.1,14.7h-2.8V8.9h3V2.6h7.2v6.3h4.6v5.8h-4.6v6.7c0,2.5,2.5,2.8,3.9,2.8c0.6,0,1,0,1,0v6.4 c-0.7,0.1-1.3,0.1-2,0.1c-3.5,0-10.3-0.9-10.3-8.3L189.1,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.5,8c6.9,0,12.5,4.6,12.5,11.6S223.5,31,216.6,31s-12.4-4.6-12.4-11.4S209.7,8,216.5,8z M216.5,24.9 c2.8,0,5-2.2,5-5c0-0.1,0-0.2,0-0.3c0-3.3-2.3-5.4-5-5.4c-2.8,0-5,2.3-5,5.1c0,0.1,0,0.2,0,0.3c-0.2,2.8,1.9,5.1,4.7,5.3 C216.3,24.9,216.4,24.9,216.5,24.9L216.5,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.9,8.5h7.1v3.7c0,0.5,0,0.9-0.1,1.4h0.1c0.9-3.1,3.7-5.3,7-5.4c0.3,0,0.6,0,0.9,0.1v7.2 c-0.5-0.1-1-0.1-1.5-0.1c-2.6-0.2-4.9,1.4-5.7,3.8c-0.3,1-0.4,2-0.4,3v8.3h-7.4L232.9,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.2,8.5h7.4v22h-7.4V8.5z M251.3,0h7.2v5.8h-7.2V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.9,8c6.5,0,10.1,4.5,10.1,10.6c0,0.7-0.2,2.3-0.2,2.3H270c0.5,2.4,2.7,4.1,5.1,3.9 c2.2-0.1,4.3-0.9,6.1-2.2l2.7,5.2c-2.7,2.1-6,3.2-9.4,3.2c-7.8,0-12.1-5.7-12.1-11.5C262.4,13.1,266.8,8,273.9,8z M276.6,16.7 c0.1-1.7-1.2-3.1-2.8-3.1c0,0,0,0-0.1,0c-2.1,0-3.1,1.5-3.5,3.1H276.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.5,22.8c1.6,1.3,3.5,2.1,5.6,2.2c1.1,0,2.2-0.3,2.2-1c0-1.9-10.3-2.1-10.3-9.3c0-4.1,4-6.7,9-6.7 s7.7,2.5,7.7,2.5l-2.5,5.2c-1.5-1.1-3.3-1.8-5.2-1.8c-1.1,0-2.2,0.3-2.2,1.1c0,1.7,10.3,1.9,10.3,9c0,3.8-3.3,7-9,7 c-3.2,0-6.3-1.1-8.8-3.2L289.5,22.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteName);
export default __webpack_public_path__ + "static/media/site-name.3f08e604af6e2c224b08519eb9c84d3e.svg";
export { ForwardRef as ReactComponent };